// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Pagination_wrapper__fvp7x","dot":"Pagination_dot__urVqZ","active":"Pagination_active__5Ws95","progress":"Pagination_progress__E53Gu"};